export const metaDataConstants = {
    somethingWrong: "Something went wrong.",
    invalidTenant: "Tenant Invalid",
    fillRequiredFields: "Please fill all required field",
    invalidCreds: "Invalid credentials. !",
    tenantLabel: "Tenant",
    signInLabel: "Sign in",
    userNameLabel: "Username",
    userNamePlaceHolder: "Enter your Username",
    shibboSigninLabel: "Sign in with Shibboleth",
    termsNCon: "Terms & Conditions",
    privacyPol: "Privacy Policy",
    appFooter: "© Powered By: Culinary Digital Inc | Version",
    accountNotForUser: "Accounts not available for this user",
    yearMonthDateFormat: "yyyy-MM-dd",
    storageAreaRequired: "Storage Area is required.",
    noStorageArea: "No storages found",
    barcodeInvDetails: "Barcode Inventory Details",
    noPermissionForInv: "You do not have permission to do Inventory",
    loginAgain: "Something went wrong. Please login again.",
    appSettingUp: "Setting up app, Please wait.",
    dataFromPrevScanPresent: "You have unsaved data from previous scans",
    submitOrDiscard: "Please submit or discard the saved data to continue",
    submit: "Submit",
    discard: "Discard",
    inmateForm: "Inmate Form",
    inmateRecord: "Inmate Record",
    back: "Back",
    youAreOffline: "It appears you're offline. To access the information, please reconnect to the internet.",
    accountName: "Account Name",
    twoDBarcodeScanner: "2d-Barcode Scanner",
    invertoryRecords: "Inventory Records",
    accountLabel: "Account",
    locationLabel: "Location",
    storageAreaLabel: "Storage Area",
    productNumberLabel: "Product Number",
    productNameLabel: "Product Name",
    unit1: "Unit 1",
    unit2: "Unit 2",
    unit3: "Unit 3",
    unitTotalQuantityLabel: "Unit Total Quantity",
    filterBy: "Filter By",
    applyFilter: "APPLY FILTER",
    reset: "Reset",
    moreNotifications: "See more Notifications",
    youAreAway: "Hello, it appears you've been away for a while",
    stayOrLogout: "If you want to continue click on Stay, if No click on Logout.",
    stay: "Stay",
    logout: "Logout",
    newVersion: "There is new version of the app available; please click on the button below to get the latest features of the app.",
    loginAgain: "You will have to Login again to use new app features",
    update: "Update",
    signOut: "Sign out",
    allNotifications: "All Notifications",
    recordsPerPage: "Records per Page:",
    dashboard: "Dashboard",
    inventory: "Inventory",
    masterSync: "Master Sync",
    transactionSync: "Transaction Sync",
    rowsPerPage: "Rows Per Page",
    period: "Period",
    dueDate: "Due Date",
    all: "All",
    codeNotScanned: "Code is not scanned properly",
    fillAllFields: "Please fill all fields.",
    productNotInAccountOrStorage: "Product does not belong to this account or storage.",
    productNotInLocationOrStorage: "Product does not belong to this location or storage.",
    productSavedSuccess: "Product Detail saved successfully.",
    unrecognizedCProduct: "Unrecognized product. Scan again or contact support.",
    submitPrevProdDetailsThenScan: "Please submit your previous product detail then scan new products.",
    wantToScanMoreProd: "Want to scan more product ?",
    yes: "Yes",
    no: "No",
    pointCameraAtBarcode: "Please point the camera at the barcode.",
    retake: "Retake barcode",
    capture: "Capture barcode",
    scan: "Scan",
    noBeepInBrowser: 'Your browser does not support the Web Audio API',
    inmateAlreadyScanned: "Inmate already scanned",
    inmateDetailsnotFound: "Inmate details not found",
    submitSuccessfull: "Submit Successful",
    submitSuccessOffline: "Submit Successful. Data will be synced once you are online",
    inmateSummary: "Inmate Summary",
    date: "Date",
    mealPeriod: "Meal Period",
    delete: "Delete",
    thankYou: "Thank You!!!",
    mealServedSuccess: "Meal is Served Successfully",
    reScan: "Re-Scan",
    inventoryDataUnavailable: "Inventory data unavailable. Choose another account or set up Inventory data correctly",
    storageCountSummary: "Storage Count Summary",
    invDueDate: "Inventory Due Date",
    counted: "Counted",
    notCounted: "Not Counted",
    total: "Total",
    status: "Status",
    completed: "Completed",
    inProgress: "In Progress",
    notStarted: "Not Started",
    extErrors : {
            username: 'The Username field is required',     
            password: 'The Password field is required',   
            textbox : 'The Tenant field is required',  
    },
    confirmDelete: "Confirm Delete",
    confirmDeleteMessage: "Are you sure you want to delete the record ?",
    deletedSuccessfully: "Deleted successfully",
    staleData: 'You have Stale data. Inventory auto sync will start in countdown seconds',
    syncingData: 'Syncing data...'
}